/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import useHasRolePermission from './useHasRolePermission';

// [ION-APP TODO]: This module has been deprecated and clients will need
// to be updated to use the `Features API` exclusively, specifically, the
// `Features.hasFeature` method.

export const ssoConfigPermission = 'sso_config';

/**
 * @deprecated - iOn Monorepo Applications are ONLY to determine Access to Features
 * via the Applications Features. References to `Permissions` is **An Anti-Pattern!**
 * and are **NOT TO BE USED!!!**. For additional information and details, please see:
 * https://calampcorp.atlassian.net/browse/IMO-174.
 *
 * This hook provides the boolean value based on logged in users sso config create permissions
 **/
export const useHasSSOCreatePermission = (): boolean => (
  useHasRolePermission(ssoConfigPermission, 'CREATE')
);

export default useHasSSOCreatePermission;
